'use client';

import { createContext, useContext, type ReactNode } from 'react';
import type { WorkspaceContextResponse } from '@mentorivo/shared';

/**
 * ETKİN ÇALIŞMA ALANI — istemci tarafındaki tek kaynak.
 *
 * ═══════════════════════════════════════════════════════════════════════════
 * Ne taşıyor, ne taşımıyor
 * ═══════════════════════════════════════════════════════════════════════════
 * Kabuğun her yerinde gereken ve sayfa geçişinde DEĞİŞMEYEN şeyler: alan
 * kimliği/slug'ı/adı, kullanıcının rolü ve yetenekleri, plan rozeti, kredi
 * bakiyesi. Hepsi `GET /workspaces/:ws/context`ten tek çağrıda geliyor ve
 * layout'ta çekiliyor — her bileşen kendi isteğini atsaydı bir sayfa
 * yüklemesinde aynı uca on kez gidilirdi.
 *
 * 🔴 BURADA YETKİ KARARI YOK. `capabilities` bir düğmeyi GİZLEMEK için;
 * "bu işlemi yapabilir miyim" sorusunun cevabı her zaman sunucuda
 * (`WorkspaceContextGuard` + `EntitlementService`). Bu ayrım kaybolursa
 * arayüzü kandıran biri yetki kazanmış olur.
 *
 * ---------------------------------------------------------------------------
 * `slug` neden ayrıca duruyor
 * ---------------------------------------------------------------------------
 * `context.workspace.slug` zaten var ama sarmalayıcı `Link` her href'te
 * ona bakıyor ve o sarmalayıcı bağlam SAĞLANMAYAN yerlerde de çalışmak
 * zorunda (giriş ekranı, pazarlama sayfaları). Bu yüzden okuyucu `null`
 * dönebiliyor ve hiçbir tüketici bağlamın varlığını varsaymıyor.
 */

const WorkspaceCtx = createContext<WorkspaceContextResponse | null>(null);

export function WorkspaceProvider({
  value,
  children,
}: {
  value: WorkspaceContextResponse;
  children: ReactNode;
}) {
  return <WorkspaceCtx.Provider value={value}>{children}</WorkspaceCtx.Provider>;
}

/**
 * Panel içindeki bileşenler için. Kabuk dışında `null` döner — çağıran
 * taraf bunu ele almak zorunda ve bu bilinçli: bağlamı zorunlu kılsaydık
 * (`throw`), ortak bir bileşen (buton, tablo) pazarlama sayfasında
 * kullanıldığı gün patlardı.
 */
export function useWorkspace(): WorkspaceContextResponse | null {
  return useContext(WorkspaceCtx);
}

/** Yalnız slug — `Link`/`useRouter` sarmalayıcılarının ihtiyacı bu kadar. */
export function useWorkspaceSlug(): string | null {
  return useContext(WorkspaceCtx)?.workspace.slug ?? null;
}
